<template>
  <div class="container">
    <center>
      <loader-component :show="loading"></loader-component>
    </center>
    <div class="row">
      <div class="col-md-12" v-if="error">
        <p>{{ error }}</p>
      </div>
    </div>
    <template v-if="!loading && !error">
      <div v-for="(licenca, index) in data" :key="index">
        <hr v-if="index > 0" class="my-2">
        <div class="row">
          <div class="col-md-4">
            <label class="text text-primary">Nome do Cliente</label>
            <span class="text">{{ licenca.nomeCliente }}</span>
          </div>
          <div class="col-md-2">
            <label class="text text-primary">Documento do Cliente</label>
            <span class="text">{{ licenca.documentoCliente }}</span>
          </div>
          <div class="col-md-2">
            <label class="text text-primary">Município do Empreendimento</label>
            <span class="text">{{ licenca.municipioEmpreendimento }}</span>
          </div>
          <div class="col-md-4">
            <label class="text text-primary">Endereço do Empreendimento</label>
            <span class="text">{{ licenca.enderecoEmpreendimento }}</span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-3">
            <label class="text text-primary">Data de Emissão</label>
            <span class="text">{{ formatDate(licenca.dataEmissao) }}</span>
          </div>
          <div class="col-md-3">
            <label class="text text-primary">Data de Validade</label>
            <span class="text">{{ formatDate(licenca.dataValidade) }}</span>
          </div>
          <div class="col-md-3">
            <label class="text text-primary">Número da Licença</label>
            <span class="text">{{ licenca.numeroLicenca }}</span>
          </div>
          <div class="col-md-3">
            <label class="text text-primary">SPU</label>
            <span class="text">{{ licenca.spu }}</span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4">
            <label class="text text-primary">Tipo de Processo</label>
            <span class="text">{{ licenca.tipoProcesso }}</span>
          </div>
          <div class="col-md-2">
            <label class="text text-primary">Código da Atividade</label>
            <span class="text">{{ licenca.codigoAtividade }}</span>
          </div>
          <div class="col-md-6">
            <label class="text text-primary">Descrição da Atividade</label>
            <span class="text">{{ licenca.descricaoAtividade }}</span>
          </div>

        </div>
      </div>
      
    </template>
  </div>
</template>

<script>
export default {
  props: ["cnpj"],
  data() {
    return {
      error: null,
      loading: true,
      data: null
    };
  },
  methods: {
    formatDate(date) {
      moment.locale('pt-br');
      return moment(date, "YYYY-MM-DD").format('L');
    },
    getData() {
      axios
        .get(`/sie/iframe/semace-api?cnpj=${this.cnpj}`)
        .then(response => response.data)
        .then(data => {
          console.log(data);
          if(data.message) this.error = data.message;
          this.data = data.data;
        })
        .catch(e => {
          console.log(e);
          this.error = "Não foi possível carregar os dados da SEMACE";
        })
        .then(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.container {
  background: #fff;
}
</style>
